<template>
  <div
    v-clickoutside="handleCloseCtxMenu"
    :style="canvasMenuStyle"
    class="canvasMenuClass"
  >
    <div @click="handleClickGrid">{{$t('lcd.Editor.Grid Settings')}}</div>
  </div>
</template>

<script>
import store from '../../../store/index.js'
import Clickoutside from '../../../utils/clickoutside'

export default {
  name: 'CtxMenu',
  directives: {
    Clickoutside
  },
  computed: {
    // 右键菜单的样式
    canvasMenuStyle() {
      return {
        display: store.state.canvasMenuVisible ? 'block' : 'none',
        // 减一是让菜单弹出来的时候就选第一个菜单项
        left: store.state.canvasMenuLeft - 1 + 'px',
        top: store.state.canvasMenuTop - 1 + 'px'
      }
    }
  },
  methods: {
    // 如果在右键菜单显示的时候。点击外部。隐藏自己
    handleCloseCtxMenu() {
      if (store.state.canvasMenuVisible) {
        store.updateCanvasMenuArgs(false)
      }
    },
    handleClickGrid() {
      store.updateGridMenuArgs(true, store.state.canvasMenuLeft, store.state.canvasMenuTop)
      store.updateCanvasMenuArgs(false)
    }
  }
}
</script>

<style lang="scss" scoped>
  // 右键菜单
  .canvasMenuClass {
    border-radius: 4px;
    position: absolute;
    background: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    z-index: 11;
    > div {
      cursor: pointer;
      padding: 4px 8px;
      user-select: none;
      &:not(.divider):hover {
        background: #f66;
        color: #fff;
        border-radius: 4px;
      }
      &:first-of-type {
        border-radius: 4px 4px 0 0;
      }
      &:last-of-type {
        border-radius: 0 0 4px 4px;
      }
      &.divider {
        height: 1px;
        margin: 4px 4px;
        padding: 0;
        background-color: #aaa;
      }
    }
  }
</style>
